const cookiesMap = {
  session: "JSESSIONID",
  listingPageSize: "listing_page_size"
}

export type CookieKey = keyof typeof cookiesMap
export default cookiesMap
